import { motion } from 'framer-motion';
import { steps } from '../data/site';
import SectionHeader from './SectionHeader';

export default function HowItWorks() {
  return (
    <section className="bg-white py-24 dark:bg-white/[0.03]" id="how-it-works">
      <div className="container-page">
        <SectionHeader
          eyebrow="How it works"
          title="Import, refine, publish. No messy middle."
          description="A focused workflow keeps every product reviewable before it becomes a live Shopify listing."
        />
        <div className="mt-14 grid gap-5 lg:grid-cols-3">
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ delay: index * 0.08, duration: 0.5 }}
              className="relative rounded-2xl border border-slate-200 bg-cloud p-7 dark:border-white/10 dark:bg-[#07111f]"
            >
              <span className="text-sm font-semibold text-slate-400">0{index + 1}</span>
              <div className="mt-5 grid h-12 w-12 place-items-center rounded-2xl bg-slate-950 text-white dark:bg-white dark:text-slate-950">
                <step.icon size={22} />
              </div>
              <h3 className="mt-8 text-xl font-semibold text-slate-950 dark:text-white">
                {step.title}
              </h3>
              <p className="mt-3 leading-7 text-slate-600 dark:text-slate-300">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
